'use strict';

import setModalVideo from "../../../frontend/js/video-modal";

class CampaignHeroVideoPlayer {
    constructor() {
        const videoButtonWrapper = document.querySelector('.campaign-hero__video-button-wrapper');
        const heroBackgroundVideoBtn = document.querySelector('.campaign-hero__background-button-container');

        if (videoButtonWrapper && videoButtonWrapper.dataset.videoUrl) {
            videoButtonWrapper.addEventListener('click', function (event) {
                if (event.which !== 1) 
                    return;

                let videoUrl = videoButtonWrapper.dataset.videoUrl.replace("watch?v=", "embed/").replace("live/", "embed/");
                videoUrl += "?autoplay=1&mute=1";
                setModalVideo({ videoUrl, videoHost: videoUrl.includes("youtube") || videoUrl.includes("youtu.be") ? "youtube" : null })
            });
        }

        if (heroBackgroundVideoBtn) {
            heroBackgroundVideoBtn.addEventListener('click', function (event) {
                if (event.which !== 1) return;
                const backgroundBtn = document.querySelector('.campaign-hero__background-button');
                if(backgroundBtn.classList.contains('campaign-hero__background-button--play')) {
                    const pauseIcon = document.querySelector('.fa-circle-pause');
                    document.querySelector('.campaign-hero__background-video').pause();
                    pauseIcon.classList.remove('fa-circle-pause');
                    pauseIcon.classList.add('fa-circle-play');
                    backgroundBtn.classList.remove('campaign-hero__background-button--play');
                    backgroundBtn.classList.add('campaign-hero__background-button--pause');
                    backgroundBtn.innerText = "Spela video";
                }
                else {
                    const playIcon = document.querySelector('.fa-circle-play');
                    document.querySelector('.campaign-hero__background-video').play();
                    playIcon.classList.add('fa-circle-pause');
                    playIcon.classList.remove('fa-circle-play');
                    backgroundBtn.classList.add('campaign-hero__background-button--play');
                    backgroundBtn.classList.remove('campaign-hero__background-button--pause');
                    backgroundBtn.innerText = "Pausa video";
                }
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new CampaignHeroVideoPlayer();
});
